import React from "react";
import _ from 'i18n';

const EventLineChartErrorHandler = ({ type, fetchRegistrantLineChartCAData, fetchRegistrantLineChartData }) => {
  const handleButtonClick = () => {
    if (type === 'CA') {
      fetchRegistrantLineChartCAData();
    } else {
      fetchRegistrantLineChartData();
    }
  };

  return (
    <div className={'flex items-center flex-column justify-center retry-container'} style={{ minHeight: '300px' }}>
      <div className={'retry-label mb-3'}>{_('ERROR_OCCURED')}</div>
      <button type="button" className={'retry-button'} onClick={handleButtonClick}>
        {_('RETRY')}
      </button>
    </div>
  );
};

export default EventLineChartErrorHandler;







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartErrorHandler.js